import type { InternalApi } from 'nitropack/types'

export const withParams = <T extends (keyof InternalApi | string)>(path: T, params: Record<string, string>) => {
  const keys = Object.keys(params).sort((a, b) => b.length - a.length)
  const cKeys = keys.map(k => ':' + k)
  return path.split(new RegExp(`(${cKeys.join('|')})`, 'g'))
    .map(chunk => cKeys.includes(chunk) ? params[chunk.substring(1)] : chunk)
    .join('') as T
}

export const wp = withParams
